import { h, Component } from 'preact'
import App from './components/app'
import Login from './components/login/Login'
import Splash from './components/splash/Splash'
import userApi from './api/user/user'
import { setUser } from './api/user/actions'

class Bootstrap extends Component {
  state = {
    userStatusKnown: false,
  }
  componentDidMount() {
    userApi.get().then(
      user => {
        this.props.setUser(user)
        this.setState({ userStatusKnown: true })
      },
      e => {
        console.error('error:', e)
        this.props.setUser(null)
        this.setState({ userStatusKnown: true })
      },
    )
  }
  render({ user }, { userStatusKnown }) {
    let view = <Splash />
    if (userStatusKnown && user) {
      view = <App />
    }
    if (userStatusKnown && !user) {
      view = <Login />
    }
    return view
  }
}

import { connect } from 'preact-redux'

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUser: user => dispatch(setUser(user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Bootstrap)



// WEBPACK FOOTER //
// ./Bootstrap.js